import React from 'react';
import { composeRenderProps, type InputProps, Input as RACInput } from 'react-aria-components';
import { fieldBorderStyles } from '../FieldGroup';
import { tv } from 'tailwind-variants';
import { cn } from '~/shared/components/utils';

export const textInputStyles = tv({
	extend: fieldBorderStyles,
	base: 'w-full rounded-md border bg-white px-4 py-2.5 text-sm text-gray-900 read-only:bg-gray-50 disabled:bg-gray-50 disabled:text-gray-500',
	variants: {
		isSuggested: {
			true: 'border-primary-500/10 bg-primary-500/5'
		},
		isReadOnly: {
			true: 'bg-gray-50 forced-colors:bg-[Canvas]'
		}
	},
	compoundVariants: [{ isFocusWithin: true, isInvalid: true, class: 'border-gray-600 forced-colors:border-[Highlight]' }]
});

export interface TextInputProps extends InputProps {
	ref?: React.Ref<HTMLInputElement>;
	isFocused?: boolean;
	isFocusVisible?: boolean;
	isFocusWithin?: boolean;
	isInvalid?: boolean;
	isDisabled?: boolean;
	isSuggested?: boolean;
}

export function TextInput({ isFocused, isFocusVisible, isFocusWithin, isInvalid, isDisabled, isSuggested, ...props }: TextInputProps) {
	return (
		<RACInput
			{...props}
			disabled={props.disabled ?? isDisabled}
			className={composeRenderProps(props.className, (className, renderProps) => {
				const styleProps = {
					...renderProps,
					isInvalid: renderProps.isInvalid || isInvalid,
					isSuggested,
					isReadOnly: props.readOnly,
					isFocusWithin: isFocused || isFocusWithin
				};
				return cn(textInputStyles(styleProps), className);
			})}
		/>
	);
}
